import { render } from "./TagLabel.vue?vue&type=template&id=62566eaa"
import script from "./TagLabel.vue?vue&type=script&lang=js"
export * from "./TagLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__